// extracted by mini-css-extract-plugin
export var closeButton = "_g9-2";
export var closeButtonIcon = "_g9-3";
export var lightboxContent = "_g9-1";
export var lightboxOverlay = "_g9-0";